import { setOptions } from './internal/index.js';

function configure(options) {
  setOptions(options);
}

export default configure;
